import { textFormatting } from '@yola/ws-sdk';
import isElementSelected from './is-element-selected';

const { wrappersTypes } = textFormatting.constants;

const isLinkSelected = () => isElementSelected(wrappersTypes.link);

export default isLinkSelected;
